import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportErrorRatioChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.errors",
		title: "Errors-to-Stops Ratio",
		yAxisLabel: "Error Ratio (%)"
	} ),

	computed: {
		itemsErrorPercents() {
			return this.items.map( item => {
				const numSchedules = item.stats.schedules.reduce( ( acc, schedule ) => acc + schedule.value, 0 );

				if ( numSchedules ) {
					return parseFloat( ( item.stats.errors / numSchedules * 100 ).toFixed( 1 ) );
				}

				return 0;
			} );
		},

		itemErrorPercent() {
			const numSchedules = this.item.stats.schedules.reduce( ( acc, schedule ) => acc + schedule.value, 0 );

			if ( numSchedules ) {
				return parseFloat( ( this.item.stats.errors / numSchedules * 100 ).toFixed( 1 ) );
			}

			return 0;
		},


		itemsAverageValue() {
			const numSchedules = this.items.reduce(
				( acc, item ) => acc + item.stats.schedules.reduce( ( acc2, schedule ) => acc2 + schedule.value, 0 ),
				0
			);

			if ( numSchedules ) {
				const numErrors = this.items.reduce( ( acc, item ) => acc + item.stats.errors, 0 );

				return parseFloat( ( numErrors / numSchedules * 100 ).toFixed( 1 ) );
			}

			return 0;
		},

		barData() {
			if ( this.item ) {
				return [
					this.itemErrorPercent,
					this.itemsAverageValue
				];
			}

			return this.itemsErrorPercents;
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "stops" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};

